import { render, staticRenderFns } from "./RefMultiSelect.vue?vue&type=template&id=63928461"
import script from "./RefMultiSelect.vue?vue&type=script&lang=ts"
export * from "./RefMultiSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports